import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  row: css({
    borderTop: `1px solid ${colors.geyser}`,
  }),

  cell: css({
    padding: spacing.default,
  }),
}

export default styles
